import React from 'react';
import AccordionWrapper from '@/components/accordion/AccordionWrapper';
import SimpleAccordion from '@/components/accordion/SimpleAccordion';
import { PANELS } from '../constants';
import UsergroupUsersTable from '../containers/UsergroupUsersTable';

const UsergroupPanelAccordion = ({
  category,
  code,
  isDuplicate,
  panels,
  updatePanels,
}) => (
  <AccordionWrapper fluid open className="aridhia-usergroup-panel-accordion mt-20">
    <SimpleAccordion
      active={panels?.includes(PANELS.USERS)}
      onClick={() => updatePanels(category, code, PANELS.USERS)}
      index={PANELS.USERS}
      headerId="usergroup.breadcrumb.users_title"
    >
      <UsergroupUsersTable code={code} category={category} isDuplicate={isDuplicate} />
    </SimpleAccordion>
  </AccordionWrapper>

);

export default UsergroupPanelAccordion;
